@if (showToggleAllocation) {
<div>
  <button type="button" ng-disabled="!moduleIsEditable" class="btn btn-primary btn-lg" (click)="toggleAllocationModule()">Allocate to this module</button>
</div>
} @else {
<div #costCenter>
  <div class="costcenter-header">
    <span class="header-lable-sm">Total Allocation: </span><span>{{ totalAllocationPct | percent:'2.2-4' }}</span>
  </div>
  <mat-drawer-container class="costcenter-container" autosize>
    <mat-drawer #drawer class="costcenter-sidenav" mode="side">
      <div class="costcenter-available-selection">
        @if (selectionInProgress) {
        <kendo-grid
          #selectionGrid
          [kendoGridInCellEditing]="createSelectionFormGroup"
          [editService]="costCenterAvailableService"
          [data]="availableCostCentersView | async"
          [filterable]="true"
          [pageable]="true"
          [skip]="availableCostCentersGridState.skip"
          [pageSize]="availableCostCentersGridState.take"
          [filter]="availableCostCentersGridState.filter"
          (dataStateChange)="availableCostCenterPageChange($event)"
          [kendoGridSelectBy]="costCenterSelectionKey"
          [(selectedKeys)]="selectedCostCenters"
          scrollable="scrollable"
          [resizable]="true"
          [style.height.px]="500">
          <ng-template kendoGridToolbarTemplate>
            <button type="button" kendoButton themeColor="primary" (click)="drawer.toggle(); addCostCenterToMapping(); toggleSelection()" [disabled]="selectedCostCenters.length === 0" class="k-button k-primary">
              Add Selected
            </button>
            <button type="button" kendoButton themeColor="primary" (click)="drawer.toggle(); toggleSelection(); cancelMappingSelection()" class="k-button k-primary">
              Cancel
            </button>
          </ng-template>
          <kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>
          <kendo-grid-column field="CostCenterNumber" [editable]="false" title="Cost Center ID"></kendo-grid-column>
          <kendo-grid-column field="Description" [editable]="false" title="Description"></kendo-grid-column>
          <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </ng-template>
        </kendo-grid>
        }
      </div>
    </mat-drawer>
    <div class="costcenter-sidenav-content">
      <kendo-grid
        [kendoGridInCellEditing]="createProjectAssetMappingFormGroup"
        [editService]="projectAssetMappingCostCenterService()"
        [data]="costCentersView | async"
        [pageable]="true"
        [skip]="costCenterGridState.skip"
        [pageSize]="costCenterGridState.take"
        (dataStateChange)="costCenterDataStateChange($event)"
        (cellClose)="editAllocationClose($event)"
        scrollable="scrollable"
        [style.height.px]="500">
        <ng-template kendoGridToolbarTemplate>
          <button type="button" kendoButton themeColor="primary" (click)="drawer.toggle(); toggleSelection()" [disabled]="!moduleIsEditable || selectionInProgress" class="k-button k-primary">
            Add
          </button>
          @if (totalCostCenters > 1) {
          <button type="button" class='k-button k-primary' kendoButton themeColor="primary" (click)='splitAllocation();'>Allocate Evenly</button>
          }
        </ng-template>
        <kendo-grid-column field="ProjectAssetMappingId" [editable]="false" [hidden]="true"></kendo-grid-column>
        <kendo-grid-column field="CostCenter.CostCenterNumber" [editable]="false" title="Cost Center ID" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ costCenterMap[dataItem.CostCenterId]?.CostCenterNumber }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CostCenter.Description" title="Description" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ costCenterMap[dataItem.CostCenterId]?.Description }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="CostCenter.CostCenterType.Description" title="Type" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ costCenterMap[dataItem.CostCenterId]?.CostCenterType?.Description }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="PercentAllocation" [editable]="allocationAllowed && moduleIsEditable" editor="numeric" title="Allocation %" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.PercentAllocation * 100 | number:'2.2-6' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-command-column title="" [width]="120">
          <ng-template kendoGridCellTemplate let-isNew="isNew">
            <button type="button" class='k-button k-primary' kendoGridRemoveCommand>Remove</button>
            <button type="button" class='k-button k-primary' kendoGridSaveCommand [disabled]="projectAssetMappingFormGroup?.invalid ?? false">Add</button>
            <button type="button" class='k-button k-primary' kendoGridCancelCommand>{{ isNew ? 'Discard' : 'Cancel' }}</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </div>
  </mat-drawer-container>
</div>
}